import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'isType',
  standalone: true,
})
export class IsTypePipe implements PipeTransform {
  public transform(value: any, type: 'number'): value is number;
  public transform(value: any, type: 'string'): value is string;
  public transform(value: any, type: 'object'): value is object;
  public transform(value: any, type: 'number' | 'string' | 'object'): boolean {
    return typeof value === type;
  }
}
